import React from 'react';
import { ReactComponent as GenAiIcon } from 'new/components/icons/genai.svg';
import { ReactComponent as CheckIcon } from 'new/components/icons/check.svg';
import { GreySpinner } from 'new/components/icons/GreySpinner/GreySpinner';
import { TooltipWithTitle } from 'new/elements/TooltipWithTitle';
import styles from './SemanticSchemaGenerateButton.module.scss';

interface SemanticSchemaGenerateButtonProps {
  isLoading?: boolean;
  isSuccess?: boolean;
  onClick: () => void;
  className?: string;
}

export function SemanticSchemaGenerateButton({
  isLoading = false,
  isSuccess = false,
  onClick,
  className = '',
}: SemanticSchemaGenerateButtonProps) {
  // Show success state only when we have success and not loading
  const showSuccess = isSuccess && !isLoading;

  const tooltipTitle = showSuccess ? 'Regenerate semantic schema' : 'Generate semantic schema';
  const tooltipDescription = "Analyze this dataset's fields for sensitivity and annotations.";

  return (
    <TooltipWithTitle
      title={<div style={{ maxWidth: '200px' }}>{tooltipTitle}</div>}
      description={<div style={{ maxWidth: '150px' }}>{tooltipDescription}</div>}
      placement="top"
      arrow={true}
      theme="dark"
    >
      <button
        className={`${styles['semantic-schema-trigger']} ${isLoading ? styles.loading : ''} ${showSuccess ? styles.success : ''} ${className}`}
        onClick={onClick}
        disabled={isLoading}
        aria-label={tooltipTitle}
        tabIndex={0}
      >
        {isLoading ? (
          <GreySpinner />
        ) : (
          <>
            <GenAiIcon className={styles['sparkles-icon']} />
            <CheckIcon className={styles['check-icon']} />
          </>
        )}
      </button>
    </TooltipWithTitle>
  );
}
